const DeliverySaverPlanDetailComponentDefinition = {
    template: require('./delivery-saver-plan-detail.component.html').trim(),
    bindings: {
        plan: '<',
    },
};

module.exports = {
    DeliverySaverPlanDetailComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/plandetail/delivery-saver-plan-detail.component.js